import { Box, CircularProgress } from "@mui/material";
import { useAtomValue } from "jotai";
import type { FC, PropsWithChildren } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { ApplicationErrorPage } from "web_myplann/Infrastructure/Pages/ApplicationErrorPage";
import { useNavigateBack } from "./Hooks/useNavigateBack";
import { apiInitializedAtom } from "./State/apiInitializedAtom";

export const MyPlannAuthenticatedRoute: FC<PropsWithChildren> = ({
	children,
}) => {
	const isApiInitialized = useAtomValue(apiInitializedAtom);

	useNavigateBack();

	const notReady = !isApiInitialized;

	if (notReady) {
		return (
			<Box
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					height: "100vh",
					top: 0,
					left: 0,
				}}
			>
				<CircularProgress />
			</Box>
		);
	}

	return (
		<ErrorBoundary FallbackComponent={ApplicationErrorPage}>
			{children}
		</ErrorBoundary>
	);
};
